import React, { useEffect } from 'react';
import LegalLayout from './LegalLayout';

const summaryLinks = [
  { href: '#escopo', label: "Escopo e aplicação desta Política" },
  { href: '#identificacao', label: "Identificação da Lumix e canal de privacidade" },
  { href: '#definicoes', label: "Definições importantes" },
  { href: '#papeis', label: "Papéis no tratamento de dados: controladora e operadora" },
  { href: '#responsabilidade-contratante', label: "Responsabilidades da Contratante sobre os dados inseridos" },
  { href: '#dados-tratados', label: "Categorias de dados pessoais tratados" },
  { href: '#dados-sensiveis', label: "Dados pessoais sensíveis, receitas e informações de saúde" },
  { href: '#finalidades', label: "Finalidades do tratamento" },
  { href: '#bases-legais', label: "Bases legais utilizadas" },
  { href: '#whatsapp', label: "WhatsApp, mensagens, campanhas e automações" },
  { href: '#anexos', label: "Arquivos, imagens, anexos e documentos" },
  { href: '#compartilhamento', label: "Compartilhamento de dados e suboperadores" },
  { href: '#transferencia', label: "Transferência internacional de dados" },
  { href: '#cookies', label: "Cookies, tecnologias similares e dados de navegação" },
  { href: '#seguranca', label: "Segurança da informação" },
  { href: '#incidentes', label: "Incidentes de segurança e comunicação" },
  { href: '#retencao', label: "Retenção, backup, exclusão e portabilidade" },
  { href: '#direitos', label: "Direitos dos titulares de dados" },
  { href: '#menores', label: "Dados de crianças, adolescentes e representantes legais" },
  { href: '#decisoes', label: "Decisões automatizadas, perfis e relatórios" },
  { href: '#confidencialidade', label: "Confidencialidade e acesso interno" },
  { href: '#atualizacoes', label: "Alterações desta Política" },
  { href: '#contato', label: "Contato para privacidade e proteção de dados" }
];

const privacySections = [
{
  "id": "escopo",
  "title": "1. Escopo e aplicação desta Política",
  "paragraphs": [
    "Esta Política de Privacidade (“Política”) explica como a Lumix Óticas trata dados pessoais no contexto de seu site institucional, páginas de venda, checkout, painel administrativo, sistema de gestão, ordens de serviço, CRM, campanhas, automações, integrações, anexos, suporte, atendimento e demais recursos disponibilizados pela plataforma Lumix Óticas (“Plataforma”).",
    "Esta Política deve ser lida em conjunto com os Termos de Uso e Contrato de Prestação de Serviços SaaS da Lumix Óticas, pois ambos formam o conjunto de regras aplicáveis à contratação, ao uso da Plataforma e ao tratamento de dados pessoais no ambiente Lumix.",
    "A Plataforma é voltada prioritariamente para uso empresarial por óticas, redes de óticas, gestores, administradores, colaboradores e profissionais autorizados pela empresa contratante. O tratamento de dados de clientes finais, pacientes, leads, consumidores e contatos cadastrados na Plataforma ocorre, em regra, por iniciativa e responsabilidade da empresa contratante."
  ]
},
{
  "id": "identificacao",
  "title": "2. Identificação da Lumix e canal de privacidade",
  "paragraphs": [
    "Para fins desta Política, “Lumix”, “Lumix Óticas”, “nós” ou “Plataforma” significa [INSERIR RAZÃO SOCIAL], pessoa jurídica inscrita no CNPJ sob nº [INSERIR CNPJ], com sede em [INSERIR ENDEREÇO COMPLETO].",
    "Canal oficial para assuntos de privacidade, proteção de dados, solicitações de titulares, incidentes, dúvidas e comunicações relacionadas à LGPD: [INSERIR E-MAIL DE PRIVACIDADE/DPO].",
    "Canal comercial ou de suporte geral: [INSERIR E-MAIL OFICIAL] e [INSERIR WHATSAPP OFICIAL]. Solicitações de privacidade devem preferencialmente ser enviadas ao canal específico indicado acima, para correta triagem e registro."
  ]
},
{
  "id": "definicoes",
  "title": "3. Definições importantes",
  "paragraphs": [
    "Para facilitar a leitura e manter coerência com os Termos de Uso, adotamos as seguintes definições:"
  ],
  "bullets": [
    {
      "term": "Contratante ou Empresa Contratante",
      "text": "pessoa jurídica, empresário individual, MEI, profissional ou organização que contrata, testa, paga, acessa ou utiliza a Plataforma."
    },
    {
      "term": "Usuário",
      "text": "pessoa autorizada pela Contratante a acessar a Plataforma, incluindo administradores, atendentes, vendedores, gestores e colaboradores."
    },
    {
      "term": "Cliente Final ou Titular",
      "text": "pessoa física cujos dados são inseridos, importados, armazenados, consultados ou utilizados pela Contratante na Plataforma, incluindo consumidores, pacientes, leads, contatos e destinatários de mensagens."
    },
    {
      "term": "Dados da Contratante",
      "text": "dados, cadastros, arquivos, receitas, imagens, mensagens, relatórios, ordens de serviço, informações fiscais, financeiras e operacionais inseridas ou geradas pela Contratante e seus Usuários."
    },
    {
      "term": "Serviços de Terceiros ou Suboperadores",
      "text": "provedores de hospedagem, armazenamento, banco de dados, e-mail, WhatsApp/mensageria, pagamento, emissão fiscal, suporte, segurança, autenticação, análise técnica e demais fornecedores necessários à prestação dos serviços."
    },
    {
      "term": "LGPD",
      "text": "Lei nº 13.709/2018, Lei Geral de Proteção de Dados Pessoais, incluindo suas alterações, regulamentações e orientações aplicáveis da ANPD."
    }
  ]
},
{
  "id": "papeis",
  "title": "4. Papéis no tratamento de dados: controladora e operadora",
  "paragraphs": [
    "A Lumix pode atuar em papéis diferentes, conforme o contexto do tratamento de dados.",
    "Em relação aos dados inseridos pela Contratante na Plataforma sobre seus clientes finais, pacientes, leads, contatos, colaboradores e operações internas, a Contratante atua, em regra, como Controladora, pois define a finalidade, a base legal, a origem dos dados, o conteúdo inserido, os destinatários das mensagens, os critérios de contato, o tempo de uso comercial e as instruções de tratamento.",
    "Nesses casos, a Lumix atua, em regra, como Operadora, tratando os dados em nome da Contratante, dentro dos limites necessários para disponibilizar, manter, proteger, melhorar e dar suporte à Plataforma, observadas as instruções legítimas da Contratante e a legislação aplicável.",
    "A Lumix atua como Controladora quando trata dados para suas próprias finalidades, como cadastro de interessados, checkout, cobrança da assinatura, segurança da conta, prevenção a fraudes, atendimento, suporte, relacionamento comercial, marketing institucional próprio, cumprimento de obrigações legais, defesa de direitos e gestão administrativa da própria Lumix.",
    "Quando houver dúvida razoável sobre o papel aplicável a determinado tratamento, a interpretação deverá considerar o contexto, a finalidade efetiva, o grau de decisão sobre o uso dos dados e as orientações da LGPD e da ANPD."
  ]
},
{
  "id": "responsabilidade-contratante",
  "title": "5. Responsabilidades da Contratante sobre os dados inseridos",
  "paragraphs": [
    "A Contratante é responsável por garantir que possui base legal válida para coletar, cadastrar, importar, armazenar, consultar, compartilhar e utilizar dados pessoais de seus clientes finais, pacientes, leads, colaboradores e demais titulares dentro da Plataforma.",
    "A Contratante deve informar seus clientes finais sobre o tratamento de dados realizado em sua operação, manter sua própria política de privacidade quando aplicável, obter consentimentos quando necessários, respeitar preferências de comunicação, atender solicitações de titulares e cumprir obrigações legais, regulatórias, consumeristas, sanitárias, fiscais, trabalhistas e profissionais aplicáveis ao seu negócio.",
    "A Contratante declara que não inserirá na Plataforma dados obtidos de forma ilícita, abusiva, discriminatória, fraudulenta, sem base legal ou incompatível com a finalidade informada ao titular.",
    "A Lumix não audita previamente a origem, a veracidade, a licitude, a necessidade, a adequação ou a proporcionalidade dos dados inseridos pela Contratante, salvo quando necessário para segurança, suporte, investigação de abuso, ordem legal ou exercício regular de direitos."
  ]
},
{
  "id": "dados-tratados",
  "title": "6. Categorias de dados pessoais tratados",
  "paragraphs": [
    "A depender do uso da Plataforma, do plano contratado e das funcionalidades ativadas, a Lumix poderá tratar as seguintes categorias de dados pessoais:"
  ],
  "bullets": [
    {
      "term": "Dados cadastrais da Contratante",
      "text": "razão social, nome fantasia, CNPJ, inscrição estadual, endereço, unidades, telefone, WhatsApp, e-mail, responsáveis e dados administrativos."
    },
    {
      "term": "Dados de usuários da Plataforma",
      "text": "nome, e-mail, telefone, cargo, perfil de acesso, permissões, senha criptografada, status da conta, logs de autenticação, IP, dispositivo, navegador e registros de uso."
    },
    {
      "term": "Dados de clientes finais, pacientes, leads e contatos",
      "text": "nome, telefone, WhatsApp, e-mail, CPF quando informado, data de nascimento, endereço, bairro, cidade, histórico de compras, interações, preferências comerciais e dados de atendimento."
    },
    {
      "term": "Dados operacionais de ótica",
      "text": "ordens de serviço, produtos, armações, lentes, medidas ópticas, status de produção, garantia, pós-venda, manutenção, observações internas, fotos e anexos."
    },
    {
      "term": "Dados de saúde ou potencialmente sensíveis",
      "text": "informações constantes em receitas, prescrições, exames, dados relacionados à acuidade visual, grau, medidas ópticas, documentos médicos ou qualquer informação que possa revelar condição de saúde do titular."
    },
    {
      "term": "Dados financeiros e comerciais",
      "text": "plano contratado, histórico de pagamentos, status de cobrança, notas, transações, cupons, dados de checkout, faturamento, DRE, métricas e indicadores gerenciais."
    },
    {
      "term": "Dados fiscais",
      "text": "informações necessárias para emissão, consulta, armazenamento ou integração com documentos fiscais, quando a funcionalidade for utilizada."
    },
    {
      "term": "Dados técnicos e de segurança",
      "text": "logs, identificadores, cookies, eventos de sistema, registros de erro, auditoria, datas, horários, IP, user-agent, tokens, origem de requisições e metadados de operação."
    },
    {
      "term": "Dados de suporte",
      "text": "mensagens enviadas ao atendimento, prints, arquivos, gravações ou informações compartilhadas voluntariamente para diagnóstico, implantação, treinamento ou resolução de problemas."
    }
  ]
},
{
  "id": "dados-sensiveis",
  "title": "7. Dados pessoais sensíveis, receitas e informações de saúde",
  "paragraphs": [
    "A Plataforma pode permitir o cadastro, upload, armazenamento ou consulta de receitas oftálmicas, imagens de documentos, prescrições, medidas ópticas e informações relacionadas à saúde visual. Esses dados podem ser considerados dados pessoais sensíveis nos termos da LGPD.",
    "A Contratante é responsável por definir a base legal adequada para o tratamento desses dados sensíveis em sua operação, incluindo, quando aplicável, consentimento específico e destacado, tutela da saúde, cumprimento de obrigação legal ou regulatória, exercício regular de direitos, proteção à vida, prevenção à fraude, segurança do titular ou outra hipótese legal cabível.",
    "A Lumix tratará esses dados apenas na medida necessária para disponibilizar a Plataforma, armazenar anexos, viabilizar ordens de serviço, manter segurança, prestar suporte, realizar backups, cumprir obrigações legais ou atender instruções legítimas da Contratante.",
    "A Contratante deve evitar inserir dados sensíveis excessivos, desnecessários, discriminatórios ou incompatíveis com a finalidade de atendimento, confecção de produtos ópticos, garantia, histórico operacional, suporte ou cumprimento legal."
  ]
},
{
  "id": "finalidades",
  "title": "8. Finalidades do tratamento",
  "paragraphs": [
    "Os dados podem ser tratados para as seguintes finalidades, conforme o contexto e o papel da Lumix em cada operação:"
  ],
  "bullets": [
    {
      "term": "Execução da Plataforma",
      "text": "criar contas, autenticar usuários, manter sessões, exibir dados, registrar ordens de serviço, organizar clientes, estoque, financeiro, campanhas e pós-venda."
    },
    {
      "term": "Prestação de serviço SaaS",
      "text": "disponibilizar recursos contratados, processar comandos, armazenar dados, sincronizar informações, gerar relatórios e manter funcionalidades operacionais."
    },
    {
      "term": "Cobrança e gestão contratual",
      "text": "processar pagamentos, validar planos, emitir cobranças, aplicar cupons, controlar inadimplência, liberar ou restringir recursos e cumprir obrigações contratuais."
    },
    {
      "term": "Atendimento, suporte e implantação",
      "text": "diagnosticar erros, responder dúvidas, treinar usuários, analisar prints, corrigir falhas, orientar configurações e melhorar a experiência da Contratante."
    },
    {
      "term": "Comunicações operacionais",
      "text": "enviar avisos de sistema, confirmações, alertas, atualizações, mensagens transacionais, notificações de segurança e comunicações relacionadas à conta."
    },
    {
      "term": "Automações e WhatsApp",
      "text": "viabilizar, quando configurado pela Contratante, mensagens de pós-venda, aniversário, status de pedido, entrega, campanhas e relacionamento com clientes finais."
    },
    {
      "term": "Segurança e prevenção a abusos",
      "text": "proteger contas, detectar fraude, monitorar atividades suspeitas, prevenir spam, preservar integridade, controlar acessos e investigar uso indevido."
    },
    {
      "term": "Cumprimento legal e regulatório",
      "text": "cumprir ordens judiciais, solicitações de autoridades, obrigações fiscais, contábeis, regulatórias, consumeristas e normas aplicáveis."
    },
    {
      "term": "Exercício regular de direitos",
      "text": "produzir provas, registrar logs, defender interesses da Lumix, da Contratante ou de terceiros em processos administrativos, judiciais ou arbitrais."
    },
    {
      "term": "Melhoria e evolução da Plataforma",
      "text": "corrigir bugs, aprimorar desempenho, criar recursos, testar segurança, analisar uso agregado, anonimizar dados e desenvolver funcionalidades."
    },
    {
      "term": "Marketing institucional próprio",
      "text": "comunicar novidades da Lumix, ofertas, conteúdos e relacionamento comercial, respeitados os direitos de oposição e descadastramento quando aplicáveis."
    }
  ]
},
{
  "id": "bases-legais",
  "title": "9. Bases legais utilizadas",
  "paragraphs": [
    "A base legal aplicável dependerá da finalidade, do contexto e do papel da Lumix como Controladora ou Operadora. Entre as bases legais que podem ser utilizadas estão: execução de contrato ou procedimentos preliminares, cumprimento de obrigação legal ou regulatória, legítimo interesse, exercício regular de direitos, proteção do crédito, prevenção à fraude, segurança do titular e consentimento quando exigido.",
    "Para dados pessoais sensíveis, a base legal deverá observar as hipóteses específicas previstas na LGPD, incluindo consentimento específico e destacado quando necessário, cumprimento de obrigação legal ou regulatória, exercício regular de direitos, tutela da saúde, proteção da vida ou da incolumidade física, prevenção à fraude e segurança do titular, conforme o caso.",
    "Quando a Lumix atuar como Operadora, a definição da base legal primária para dados de clientes finais caberá à Contratante, sem prejuízo das obrigações da Lumix de segurança, confidencialidade, cooperação e tratamento conforme instruções legítimas."
  ]
},
{
  "id": "whatsapp",
  "title": "10. WhatsApp, mensagens, campanhas e automações",
  "paragraphs": [
    "A Plataforma pode permitir integrações, automações, templates, campanhas, mensagens de status, pós-venda, aniversário, avisos de entrega, lembretes e comunicações por WhatsApp ou outros canais de mensageria.",
    "A Contratante é responsável por garantir que possui autorização, base legal, relação legítima ou outra justificativa válida para contatar seus clientes finais por WhatsApp, telefone, e-mail ou outros canais, bem como por respeitar pedidos de descadastramento, oposição, bloqueio ou interrupção de contato.",
    "É proibido utilizar a Plataforma para spam, disparos abusivos, conteúdo enganoso, mensagens discriminatórias, assédio, fraude, propaganda irregular, violação de direitos de terceiros, uso político ilícito ou qualquer comunicação incompatível com a legislação e com as regras das plataformas de mensageria.",
    "A Lumix poderá limitar, suspender ou bloquear funcionalidades de envio de mensagens em caso de risco à segurança, abuso, denúncia, uso anormal, infração legal, violação dos Termos de Uso ou risco à reputação técnica da Plataforma."
  ]
},
{
  "id": "anexos",
  "title": "11. Arquivos, imagens, anexos e documentos",
  "paragraphs": [
    "A Plataforma pode permitir upload e armazenamento de fotos, documentos, receitas, anexos, comprovantes, imagens de armações, imagens de ordens de serviço e outros arquivos vinculados à operação da Contratante.",
    "A Contratante é responsável pelo conteúdo enviado, pela origem dos arquivos, pela autorização de uso, pela necessidade do armazenamento e pela conformidade desses documentos com a legislação aplicável.",
    "A Lumix poderá aplicar compressão, conversão, validação técnica, renomeação, organização por diretórios, controle de acesso e outras medidas para otimizar armazenamento, segurança, performance e disponibilidade, sem alterar intencionalmente o significado operacional do documento.",
    "A Lumix não se responsabiliza por conteúdo ilícito, incorreto, excessivo, desatualizado ou enviado indevidamente por Usuários da Contratante, sem prejuízo da possibilidade de remoção, bloqueio ou preservação quando exigido por lei, ordem de autoridade ou segurança."
  ]
},
{
  "id": "compartilhamento",
  "title": "12. Compartilhamento de dados e suboperadores",
  "paragraphs": [
    "A Lumix poderá compartilhar dados com terceiros apenas quando necessário para prestar, proteger, melhorar, cobrar, auditar ou manter a Plataforma, cumprir obrigações legais, atender autoridades ou exercer direitos.",
    "Esses terceiros podem incluir provedores de hospedagem, infraestrutura, banco de dados, armazenamento, CDN, backup, monitoramento, e-mail, autenticação, gateways de pagamento, APIs fiscais, serviços de mensageria, suporte, análise técnica, segurança e ferramentas administrativas.",
    "Quando aplicável, a Lumix exigirá de seus fornecedores medidas compatíveis de confidencialidade, segurança e proteção de dados, observando a natureza do tratamento e os riscos envolvidos.",
    "A Lumix não comercializa dados pessoais de clientes finais da Contratante. Dados agregados, estatísticos ou anonimizados poderão ser utilizados para análise, melhoria, segurança, benchmarking, pesquisa, desenvolvimento e comunicação institucional, desde que não permitam identificar titulares de forma razoável."
  ],
  "sublistTitle": "Exemplos de categorias de terceiros que podem participar da operação:",
  "subbullets": [
    "provedores de cloud, VPS, banco de dados, armazenamento e backups;",
    "gateway de pagamento e intermediadores financeiros;",
    "provedores de envio de e-mail, notificações e mensagens;",
    "serviços de emissão, consulta ou integração fiscal, quando ativados;",
    "ferramentas de monitoramento, logs, segurança e suporte técnico;",
    "autoridades públicas, órgãos reguladores ou partes envolvidas em disputa, quando houver obrigação legal ou exercício regular de direitos."
  ]
},
{
  "id": "transferencia",
  "title": "13. Transferência internacional de dados",
  "paragraphs": [
    "Alguns fornecedores utilizados pela Lumix ou pela Contratante podem operar infraestrutura, suporte, processamento, armazenamento, backup, segurança ou ferramentas em outros países.",
    "Quando houver transferência internacional de dados pessoais sob responsabilidade da Lumix, serão adotadas medidas compatíveis com a LGPD, com a regulamentação da ANPD e com mecanismos reconhecidos, como cláusulas contratuais, garantias adequadas, decisões de adequação, normas corporativas globais ou outras hipóteses legais aplicáveis.",
    "Quando a transferência internacional decorrer de ferramenta, integração ou fornecedor escolhido diretamente pela Contratante, esta será responsável por avaliar a adequação jurídica do uso desse terceiro em sua operação."
  ]
},
{
  "id": "cookies",
  "title": "14. Cookies, tecnologias similares e dados de navegação",
  "paragraphs": [
    "A Lumix pode utilizar cookies, pixels, identificadores, armazenamento local, logs e tecnologias similares para manter sessões, lembrar preferências, proteger contas, medir desempenho, diagnosticar falhas, prevenir fraude, analisar navegação e melhorar a experiência do usuário.",
    "Cookies estritamente necessários podem ser utilizados independentemente de consentimento, quando indispensáveis ao funcionamento seguro da Plataforma. Cookies analíticos, de marketing ou não essenciais poderão ser gerenciados conforme os mecanismos disponíveis no site, navegador ou ferramenta de consentimento adotada.",
    "O bloqueio de determinados cookies pode afetar login, segurança, preferências, estabilidade, integração, autenticação ou funcionamento de áreas restritas da Plataforma."
  ]
},
{
  "id": "seguranca",
  "title": "15. Segurança da informação",
  "paragraphs": [
    "A Lumix adota medidas técnicas e administrativas razoáveis para proteger dados pessoais contra acessos não autorizados, perda, alteração, destruição, vazamento, uso indevido, indisponibilidade e outros incidentes, considerando o estado da técnica, o porte da operação, os custos, a natureza dos dados e os riscos envolvidos.",
    "Entre as medidas possíveis estão: controle de acesso, autenticação, senhas criptografadas, segregação lógica por empresa, permissões por usuário, logs, backups, monitoramento, atualizações, correções de vulnerabilidades, limitação de privilégios, proteção de rotas, análise de falhas e boas práticas de desenvolvimento seguro.",
    "A segurança também depende da Contratante e de seus Usuários. A Contratante deve usar senhas fortes, proteger dispositivos, encerrar acessos de ex-colaboradores, evitar compartilhamento de credenciais, treinar sua equipe, revisar permissões e notificar imediatamente a Lumix em caso de suspeita de acesso indevido.",
    "Nenhum sistema é absolutamente invulnerável. A Lumix não promete segurança absoluta, mas compromete-se a empregar medidas proporcionais e razoáveis para mitigar riscos e responder a incidentes conforme a legislação aplicável."
  ]
},
{
  "id": "incidentes",
  "title": "16. Incidentes de segurança e comunicação",
  "paragraphs": [
    "Caso identifique incidente de segurança envolvendo dados pessoais que possa acarretar risco ou dano relevante aos titulares, a Lumix adotará medidas razoáveis de contenção, investigação, mitigação, registro, comunicação e cooperação, conforme seu papel no tratamento e a legislação aplicável.",
    "Quando a Lumix atuar como Operadora, comunicará a Contratante em prazo razoável após tomar ciência confirmada do incidente, fornecendo as informações disponíveis e necessárias para que a Contratante avalie suas obrigações como Controladora.",
    "Quando a Lumix atuar como Controladora e o incidente exigir comunicação à ANPD e/ou aos titulares, a Lumix seguirá os prazos e procedimentos aplicáveis, observada a regulamentação vigente.",
    "A Contratante deve comunicar imediatamente à Lumix qualquer suspeita de invasão, credencial comprometida, uso indevido, vazamento, perda de dispositivo, envio incorreto de dados ou incidente relacionado à sua conta."
  ]
},
{
  "id": "retencao",
  "title": "17. Retenção, backup, exclusão e portabilidade",
  "paragraphs": [
    "Os dados serão mantidos pelo tempo necessário para cumprir as finalidades desta Política, executar o contrato, prestar a Plataforma, manter histórico operacional, cumprir obrigações legais, fiscais, regulatórias, contábeis e consumeristas, preservar segurança, prevenir fraude e exercer direitos.",
    "Após o encerramento da conta, cancelamento ou término do contrato, a Lumix poderá manter os dados por período razoável para viabilizar exportação, auditoria, backup, prevenção de perdas, cumprimento legal, cobrança, defesa de direitos e resolução de disputas.",
    "A exclusão definitiva pode não ocorrer imediatamente em backups, logs, réplicas técnicas e arquivos de segurança, que serão eliminados ou sobrescritos conforme ciclos técnicos e políticas internas, salvo obrigação legal, ordem de autoridade ou necessidade de preservação de direitos.",
    "A Contratante deve solicitar exportação ou cópia dos Dados da Contratante antes do cancelamento definitivo, observados os recursos disponíveis, limites técnicos, formato de exportação e eventuais condições comerciais aplicáveis."
  ]
},
{
  "id": "direitos",
  "title": "18. Direitos dos titulares de dados",
  "paragraphs": [
    "Nos termos da LGPD, titulares podem solicitar, conforme aplicável: confirmação de tratamento, acesso, correção, anonimização, bloqueio, eliminação, portabilidade, informação sobre compartilhamento, revisão de decisões automatizadas, revogação de consentimento e oposição a tratamentos irregulares.",
    "Quando a solicitação envolver dados de clientes finais, pacientes, leads ou contatos cadastrados pela Contratante, a solicitação deverá ser direcionada preferencialmente à própria Contratante, que é a Controladora e mantém a relação direta com o titular.",
    "Se a Lumix receber solicitação relacionada a dados controlados pela Contratante, poderá orientar o titular a procurar a Contratante, encaminhar a solicitação quando possível, ou cooperar tecnicamente com a Contratante para atendimento da requisição, dentro dos limites legais, contratuais e técnicos.",
    "Solicitações podem exigir validação de identidade, informações complementares e prazo razoável de resposta. A Lumix poderá negar pedidos quando houver fundamento legal, impossibilidade técnica, risco a terceiros, sigilo comercial, obrigação de retenção, exercício regular de direitos ou solicitação manifestamente abusiva."
  ]
},
{
  "id": "menores",
  "title": "19. Dados de crianças, adolescentes e representantes legais",
  "paragraphs": [
    "A Plataforma não é destinada ao uso direto por crianças ou adolescentes. Contudo, óticas contratantes podem inserir dados de menores de idade atendidos em sua operação, especialmente em ordens de serviço, histórico de compra, receitas, medidas ópticas ou atendimento familiar.",
    "A Contratante é responsável por garantir que o tratamento de dados de crianças e adolescentes observe o melhor interesse do menor, a legislação aplicável e, quando necessário, a participação, ciência ou autorização de pais ou responsáveis legais.",
    "A Lumix tratará esses dados apenas para disponibilizar a Plataforma e cumprir as instruções legítimas da Contratante, salvo obrigação legal, segurança ou exercício regular de direitos."
  ]
},
{
  "id": "decisoes",
  "title": "20. Decisões automatizadas, perfis e relatórios",
  "paragraphs": [
    "A Plataforma pode gerar relatórios, filtros, segmentações, indicadores, alertas, listas de aniversariantes, réguas de relacionamento, status de clientes, históricos e sugestões operacionais com base nos dados cadastrados pela Contratante.",
    "Esses recursos são ferramentas de apoio à gestão e à comunicação. A Contratante é responsável por revisar os resultados, validar a pertinência das campanhas, evitar discriminação, corrigir dados incorretos e decidir se utilizará ou não determinada ação sugerida pela Plataforma.",
    "A Lumix não realiza, por padrão, decisões automatizadas com efeitos jurídicos relevantes sobre clientes finais em nome próprio. Caso novas funcionalidades com esse potencial sejam disponibilizadas, a Política poderá ser atualizada e mecanismos apropriados poderão ser adotados."
  ]
},
{
  "id": "confidencialidade",
  "title": "21. Confidencialidade e acesso interno",
  "paragraphs": [
    "A Lumix limitará o acesso interno aos dados pessoais a pessoas autorizadas e somente quando necessário para suporte, segurança, operação, manutenção, auditoria, desenvolvimento, cumprimento legal ou exercício de direitos.",
    "Colaboradores, prestadores e fornecedores que tenham acesso a dados deverão observar deveres de confidencialidade e proteção compatíveis com a natureza das informações acessadas.",
    "A Contratante também deve impor deveres de confidencialidade aos seus Usuários e colaboradores, principalmente quando acessarem receitas, documentos, informações de saúde, dados financeiros, dados de clientes finais ou informações comerciais sensíveis."
  ]
},
{
  "id": "atualizacoes",
  "title": "22. Alterações desta Política",
  "paragraphs": [
    "Esta Política poderá ser atualizada para refletir mudanças legais, regulatórias, tecnológicas, operacionais, comerciais, de segurança, de recursos da Plataforma ou de fornecedores envolvidos na prestação dos serviços.",
    "Mudanças relevantes poderão ser comunicadas por e-mail, aviso no painel, notificação no site, WhatsApp oficial, atualização de versão ou outro meio razoável.",
    "O uso contínuo da Plataforma após a publicação da versão atualizada indica ciência da nova Política, sem prejuízo de direitos legais aplicáveis."
  ]
},
{
  "id": "contato",
  "title": "23. Contato para privacidade e proteção de dados",
  "paragraphs": [
    "Para dúvidas, solicitações de titulares, comunicações de incidentes, pedidos de cooperação da Contratante ou assuntos relacionados à proteção de dados, utilize o canal: [INSERIR E-MAIL DE PRIVACIDADE/DPO].",
    "Para suporte operacional, financeiro ou comercial, utilize: [INSERIR E-MAIL OFICIAL] e [INSERIR WHATSAPP OFICIAL].",
    "Recomenda-se que a Contratante mantenha canal próprio de atendimento aos titulares de seus clientes finais, já que, na maioria dos tratamentos realizados dentro da Plataforma, a Contratante é a Controladora dos dados."
  ]
},
{
  "id": "referencias",
  "title": "24. Referências normativas consideradas",
  "paragraphs": [
    "Esta Política foi estruturada considerando, entre outras normas e orientações: Lei nº 13.709/2018 (LGPD); Lei nº 12.965/2014 (Marco Civil da Internet); guias e orientações da Autoridade Nacional de Proteção de Dados (ANPD) sobre agentes de tratamento, encarregado, incidentes de segurança e transferência internacional de dados; e demais normas brasileiras aplicáveis à proteção de dados, privacidade, segurança, contratos e responsabilidade civil."
  ]
}
];

const LAST_UPDATE = '28 de maio de 2026';

export default function PoliticaPrivacidade() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalLayout
      eyebrow="Privacidade e Proteção de Dados"
      title="Política de Privacidade"
      description="Esta política explica como a Lumix Óticas trata dados pessoais em seu site, checkout, painel administrativo, ordens de serviço, CRM, automações e integrações, em conformidade com a LGPD."
      summaryLinks={summaryLinks}
    >
      <style>{`
        .lumix-privacy-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 7px;
          margin: 0 0 32px;
        }

        .lumix-privacy-chip {
          min-height: 27px;
          padding: 0 10px;
          display: inline-flex;
          align-items: center;
          border: 1px solid #e3e8ef;
          border-radius: 9px;
          background: #ffffff;
          color: #626a78;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 9px;
          line-height: 1;
          font-weight: 700;
          box-shadow: 0 1px 2px rgba(15,23,42,.03);
        }

        .lumix-privacy-section {
          scroll-margin-top: 96px;
        }

        .lumix-privacy-section h2 {
          position: relative;
          margin: 42px 0 15px;
          padding-bottom: 13px;
          border-bottom: 1px solid #e6ebf1;
          color: #171a21;
          font-family: 'Nunito', 'Inter', system-ui, sans-serif;
          font-size: 1.22rem;
          line-height: 1.35;
          font-weight: 900;
          letter-spacing: -.025em;
        }

        .lumix-privacy-section h2::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -1px;
          width: 42px;
          height: 2px;
          border-radius: 999px;
          background: #1a73e8;
        }

        .lumix-privacy-section:first-of-type h2 {
          margin-top: 0;
        }

        .lumix-privacy-section p {
          margin: 0 0 15px;
          color: #46505f;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 0.92rem;
          line-height: 1.82;
          font-weight: 450;
        }

        .lumix-privacy-list {
          margin: 8px 0 22px;
          padding-left: 1.3rem;
        }

        .lumix-privacy-list li {
          margin: 0 0 8px;
          padding-left: 3px;
          color: #46505f;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 0.91rem;
          line-height: 1.78;
          font-weight: 450;
        }

        .lumix-privacy-list li::marker {
          color: #1a73e8;
        }

        .lumix-privacy-term {
          color: #20242c;
          font-weight: 800;
        }

        .lumix-privacy-note {
          position: relative;
          margin-top: 42px;
          padding: 15px 17px 15px 20px;
          border: 1px solid #e1e8f0;
          border-radius: 13px;
          background: #fafcfe;
          color: #626a78;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 11px;
          line-height: 1.65;
          font-weight: 500;
        }

        .lumix-privacy-note::before {
          content: '';
          position: absolute;
          left: 0;
          top: 12px;
          bottom: 12px;
          width: 3px;
          border-radius: 0 999px 999px 0;
          background: #1a73e8;
        }

        .lumix-privacy-note strong {
          color: #343943;
          font-weight: 800;
        }

        @media (max-width: 720px) {
          .lumix-privacy-meta {
            gap: 6px;
            margin-bottom: 26px;
          }

          .lumix-privacy-chip {
            min-height: 25px;
            padding: 0 8px;
            font-size: 8px;
          }

          .lumix-privacy-section h2 {
            margin-top: 34px;
            font-size: 1.06rem;
          }

          .lumix-privacy-section p,
          .lumix-privacy-list li {
            font-size: 0.86rem;
            line-height: 1.75;
          }

          .lumix-privacy-list {
            padding-left: 1.15rem;
          }

          .lumix-privacy-note {
            margin-top: 34px;
            padding: 13px 14px 13px 17px;
            font-size: 10px;
          }
        }
      `}</style>

      <div className="lumix-privacy-meta" aria-label="Informações rápidas da política">
        <span className="lumix-privacy-chip">Última atualização: {LAST_UPDATE}</span>
        <span className="lumix-privacy-chip">SaaS B2B</span>
        <span className="lumix-privacy-chip">Alinhada aos Termos de Uso</span>
        <span className="lumix-privacy-chip">LGPD e ANPD</span>
      </div>
{privacySections.map((section) => (
        <section className="lumix-privacy-section" id={section.id} key={section.id}>
          <h2>{section.title}</h2>

          {section.paragraphs?.map((paragraph, index) => (
            <p key={`p-${section.id}-${index}`}>{paragraph}</p>
          ))}

          {section.bullets?.length > 0 && (
            <ul className="lumix-privacy-list">
              {section.bullets.map((item, index) => (
                <li key={`b-${section.id}-${index}`}>
                  {item.term ? (
                    <>
                      <span className="lumix-privacy-term">{item.term}:</span> {item.text}
                    </>
                  ) : (
                    item.text
                  )}
                </li>
              ))}
            </ul>
          )}

          {section.sublistTitle && <p>{section.sublistTitle}</p>}

          {section.subbullets?.length > 0 && (
            <ul className="lumix-privacy-list">
              {section.subbullets.map((item, index) => (
                <li key={`sb-${section.id}-${index}`}>{item}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      <div className="lumix-privacy-note">
        <strong>Nota de transparência:</strong> esta Política foi construída para refletir o modelo SaaS multiempresa da Lumix Óticas, separando as responsabilidades da Lumix e da empresa contratante, especialmente no tratamento de dados de clientes finais, receitas, imagens, ordens de serviço, WhatsApp e automações.
      </div>
    </LegalLayout>
  );
}
